import React, { useState } from "react";
import ListItem from "./ListItem.js";
import Icon from "../../../Elements/Icon/Icon.tsx";
import Tooltip from "components/Elements/Tooltip/Tooltip.js";
import useSelfRemovalLink from "hooks/useSelfRemovalLink.tsx";
import FolderItem from "./FolderItem.tsx";
import FolderDivider from "../CoolGrid/FolderDivider.js";
import NoFilesComponent from "components/Pages/Gallery/GalleryContent/NoFIlesComponent.js";
import { useMail } from "../../../../contexts/mailContext/mailContext.js";
import { useContent } from "../../../../contexts/contentContext/contentContext.js";

const ColumnCaption = ({ colName }) => {
  const { setSorting, getSorting } = useMail();
  const { getTextByKey } = useContent();
  const [hover, setHover] = useState(false);

  const handleClick = (name) => {
    const isCurrent = name.toLowerCase() === getSorting().by.toLowerCase();
    setSorting({
      asc: isCurrent ? !getSorting().asc : true,
      by: name,
    });
  };

  const isFlipped = () => {
    if (getSorting().by.toLowerCase() === colName.toLowerCase()) {
      return (!getSorting().asc && !hover) || (getSorting().asc && hover)
        ? true
        : false;
    } else {
      return false;
    }
  };

  return (
    <span
      onClick={() => handleClick(colName)}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      {getTextByKey(`${colName.toLowerCase()}-sorting-caption`)}
      {getSorting().by.toLowerCase() === colName.toLowerCase() || hover ? (
        <Tooltip
          tooltipText={getTextByKey(
            getSorting().asc ? "desc-tooltip" : "asc-tooltip"
          )}
        >
          <Icon
            name="arrow-down-solid"
            small
            iconClass={isFlipped() ? "vertical-flipped" : ""}
          />
        </Tooltip>
      ) : null}
    </span>
  );
};

const ListView = () => {
  const {
    getFilesData,
    getFilesList,
    getAvailableFoldersList,
    getFolderStructured,
  } = useMail();

  const isSelfRemove = useSelfRemovalLink();

  const filesList = getFilesList();

  return (
    <div className="list-view">
      <div className="list-elem list-col-names row">
        <div className="col-6">
          <div className="select-icon-margin"></div>
          <ColumnCaption colName="Name" />
        </div>
        <div className="col-2">
          <ColumnCaption colName="Extention" />
        </div>
        <div className={`col-${isSelfRemove ? "4 text-end" : "2"}`}>
          <ColumnCaption colName="Size" />
        </div>
        <div className="col-2 text-end"></div>
      </div>
      {getFolderStructured() &&
        getAvailableFoldersList().map((folderId) => {
          return <FolderItem folderId={folderId} key={folderId} />;
        })}
      {filesList.length > 0 ? (
        filesList.map((fileId) => {
          const folderId = fileId.folder;
          if (folderId)
            return <FolderDivider folderId={folderId} key={folderId} />;
          const fileData = getFilesData()[fileId];
          return fileData ? (
            <ListItem {...{ fileId, fileData }} key={fileId} />
          ) : null;
        })
      ) : (
        <NoFilesComponent />
      )}
    </div>
  );
};

export default ListView;
